module.exports = __webpack_public_path__ + "static/media/shipSize-car.fe98626d.svg";